import { render, staticRenderFns } from "./plutus.vue?vue&type=template&id=6ce88255&"
import script from "./plutus.vue?vue&type=script&lang=js&"
export * from "./plutus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports